<script setup>
  import FormValidationMessage from '@/features/ui/components/forms/FormValidationMessage.vue'

  defineProps({
    errorMessages: {
      type: Array,
      default: () => [],
    },
  })
</script>

<template>
  <FormValidationMessage>
    <span v-for="error of errorMessages" :key="error.$message">
      {{ error.$message }}
    </span>
  </FormValidationMessage>
</template>

<style lang="scss" scoped></style>
